import React from 'react';
import { StandardMenuType } from './types';
/**
 * This context is used to determine what keyboard input handling we should be doing
 */ const StandardMenuContext = /*#__PURE__*/ React.createContext({
    menuType: StandardMenuType.DROPDOWN,
    role: undefined
});
export default StandardMenuContext;
